let basename = '/e-levy-calculator-gh';
//  let basename = '/';

export default basename;